module.exports = __webpack_public_path__ + "static/media/ottawa-47.0d11dab3.jpg";